import { Component,OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { UserService } from 'src/app/services/user.service';
@Component({
  selector: 'upsc-documents-upload-guidance',
  templateUrl: './documents-upload-guidance.component.html',
  styleUrls: ['./documents-upload-guidance.component.scss']
})
export class DocumentsUploadGuidanceComponent implements OnInit {
 portalType;

  constructor(public dialogRef:MatDialogRef<DocumentsUploadGuidanceComponent>,
    private userService:UserService
  ){}

 

  ngOnInit():void{
    this.portalType=this.userService.getUserInfo().type;
      if(!this.portalType){
      const flowTypes = JSON.parse(sessionStorage.getItem('flowType') || '{}');
      this.portalType = flowTypes.flowType;
      }
  }
   public close(){
    this.dialogRef.close();
  }
}
